import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  IconBanner,
  IconStar,
  IconTextLink,
  IconTicket,
} from '../../../../assets';
import {
  actionGeneralInfo,
  actionGetListBank,
} from '../../../../features/system/actions';
import useDashBoard from '../../../../hooks/useDashBoard';
import { routes } from '../../../../utils/constants/constant';
import MobileBreadCrumb from '../MobileBreadCrumb/MobileBreadCrumb';
import BoxItemsMobile from './BoxItemsMobile/BoxItemsMobile';
import CustomCardAffiliate from './CustomCardAffiliate/CustomCardAffiliate';
import CustomCardDashboard from './CustomCardDashboard/CustomCardDashboard';
import ListCampaign from './ListCampaign/ListCampaign';
import './MobileDashBoard.scss';
const fakeData = [
  {
    id: 1,
    title: 'Banner',
    description: 'Tạo banner với hình ảnh đẹp trên trang của bạn',
    backgroundColor: '#48BB78',
    icon: <IconBanner />,
    link: routes.DASHBOARD_BANNER,
  },
  {
    id: 2,
    title: 'Text Links',
    description: 'Đặt deep link vào nội dung của bạn',
    backgroundColor: '#ED8936',
    icon: <IconTextLink />,
    link: routes.DASHBOARD_TEXT_LINK,
  },
  {
    id: 3,
    title: 'Mã Ưu Đãi',
    description: 'Tạo banner với hình ảnh đẹp trên trang của bạn',
    backgroundColor: '#7A64D2',
    icon: <IconTicket />,
    link: routes.DASHBOARD_PROMOTION,
  },
  {
    id: 4,
    title: 'Co-branding',
    description: 'Thiết lập Trang Co-branded Landing Page của bạn',
    backgroundColor: '#9F5AB0',
    icon: <IconStar />,
    link: routes.DASHBOARD_CO_BRANDING,
  },
];

const MobileDashBoard = (props) => {
  // const { actionGeneralInfo, actionGetListBank } = props;
  const {
    filterType,
    filterDate,
    listCampaign,
    userAffiliationInfo,
    onChange,
    onChangeDate,
    getInfoGeneralInfo,
    fetListCampaign,
  } = useDashBoard({
    ...props,
  });
  const profile = props?.profile || {};
  return (
    <div
      className='mobile-dash-board'
      style={{
        pointerEvents: profile?.approvalStatus !== 'APPROVED' && 'none',
      }}
    >
      <MobileBreadCrumb />
      <div className='title-page'>Tổng quan</div>{' '}
      {profile?.approvalStatus !== 'APPROVED' && (
        <div className='warning-text'>
          *Tài khoản của quý khách chưa được phê duyệt để tham gia chương trình
          đối tác của Mytour.
        </div>
      )}
      <div className='info-grid'>
        {fakeData?.map((v, index) => (
          <BoxItemsMobile data={v} />
        ))}
      </div>
      <CustomCardDashboard userAffiliationInfo={userAffiliationInfo} />
      <CustomCardAffiliate
        getInfoGeneralInfo={getInfoGeneralInfo}
        userAffiliationInfo={userAffiliationInfo}
      />
      <div className='title-page type2' style={{ marginTop: 50 }}>
        Danh sách chiến dịch của tôi
      </div>
      <ListCampaign
        listCampaign={listCampaign}
        filterType={filterType}
        onChangeDate={onChangeDate}
        filterDate={filterDate}
        onChange={onChange}
        fetListCampaign={fetListCampaign}
      />
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
    generalInfo: state.systemReducer.generalInfo,
  }),
  { actionGeneralInfo, actionGetListBank }
)(withRouter(MobileDashBoard));
